import { Components } from "./types";

const components: Components = {
  settingsPage: () => null,
  importerSettings: () => null
};

export default components;
